//TODO: solve url and clean path 
import theMofGame from '../assets/img/covers/project1.jpg';
import gameAsPA from '../assets/img/covers/project2.png';
import fantasynth from '../assets/img/covers/project3.jpg';
import lichtspektakel from '../assets/img/covers/project4.jpg';
// import avPerformances from '../assets/img/covers/project4.jpg';

const ProjectList = [
    {
      id: 1,
      cover: theMofGame,
      url: '/projects/meaningofgame/',
      title: 'The Meaning of Game',
      description: "THE MEANING OF GAME: FP art game in browser"
    },
    {
      id: 2,
      cover: gameAsPA,
      url: '/projects/gameasperformanceart/',
      title: 'Game as Performance Art',
      description: "GAME AS PERFORMANCE ART: Standalone"
    },
    {
      id: 3,
      cover: fantasynth,
      url: '/projects/fantasynth/',
      title: 'Fantasynth',
      description: "FANTASYNTH: Real-time installation"
    },
    {
      id: 4,
      cover: lichtspektakel,
      url: '/projects/lichtspektakel/',
      title: 'Lichtspektakel',
      description: "LIGHT SPECTACLE: Projection mapping"
    }
    // {
    //   id: 5,
    //   cover: avPerformances,
    //   url: '/projects/performances/',
    //   title: 'AV Performances',
    //   description: "LIGHT SPECTACLE: Projection mapping"
    // }
]; 

export default ProjectList;
